import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { DateRangeSummaryRow } from "../models/SummaryByDateRange";

export const getAccountSummaryByDateRange = async (
	costCenterId: number,
	start: string,
	close: string,
	signal?: AbortSignal,
): Promise<DateRangeSummaryRow | null> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "costCenterId", value: costCenterId },
		{ name: "start", value: start },
		{ name: "close", value: close },
	];

	const resp = await apiService.callV2(
		"[MILL].[GetAccountSummary]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching the account summary");
	}
	const rows = get(resp, "data.tables[0].rows", []) as DateRangeSummaryRow[];
	return rows.length > 0 ? rows[0] : null;
};
